import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Card } from '../../model/card';

@Component({
  selector: 'app-small-card',
  templateUrl: './small-card.component.html',
  styleUrls: ['./small-card.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class SmallCardComponent implements OnInit {

  @Input() card: Card;

  constructor() { }

  ngOnInit() {
  }

}
